import { useEffect } from "react"
import cn from "@/v2-ui/utils/utils.cn"
import Icon from "@/v2-ui/icon"
import Command, { type CommandItemProps } from "@/v2-ui/command"
import { ConfirmButton } from "@/v2-backoffice-client/components/button"
import { useSelectorContext } from "@/v2-backoffice-client/components/selector/selector.context"

export type SelectorItemProps = CommandItemProps & {
  added?: boolean
  isLoading?: boolean
  onDeselect?(): void
}

function SelectorItem(props: SelectorItemProps) {
  const {
    className,
    value,
    added,
    disabled,
    isLoading,
    onSelect,
    onDeselect,
    children,
    ...commandItemProps
  } = props

  const { setIsLoading } = useSelectorContext()

  useEffect(() => {
    if (isLoading === undefined || !setIsLoading) return
    setIsLoading(isLoading)
  }, [isLoading, setIsLoading])

  const isDeselectable = added && !!onDeselect

  return (
    <Command.Item
      className={cn(
        "selector-item-base",
        added && "selector-item-added",
        className,
      )}
      value={value}
      disabled={(added && !onDeselect) || disabled || isLoading}
      onSelect={added ? undefined : onSelect}
      {...commandItemProps}
    >
      <div className="selector-item">
        <Icon
          className="selector-item-check"
          src={added ? "check" : undefined}
          size={14}
        />

        {children}

        {isDeselectable && (
          <div
            className="selector-item-remove"
            onClick={(e) => {
              e.stopPropagation()
            }}
            onPointerDown={(e) => {
              e.stopPropagation()
            }}
          >
            <ConfirmButton
              size="xs"
              variant="secondary"
              iconSrc="cross-small"
              content="Clear selection"
              confirmContent="Remove?"
              confirmVariant="destructive"
              onConfirm={onDeselect}
            />
          </div>
        )}
      </div>
    </Command.Item>
  )
}

export default SelectorItem
